module.exports = __webpack_public_path__ + "static/media/1002198MF.91b9c53a.jpg";